<template>
    <div>

    </div>
</template>
<script>
    export default {
      data() {
        return {
            a:0,
        }
    },
    created(){
        let  userId= this.getUrlKey("userId");
        let code=this.getUrlKey("code");
        if (userId || code) {
            if(userId) {
                this.getCorpUserInfo(userId);
            }
        }
        else{
            //window.location.href = "http://slhaoo8r.shenzhuo.vip:11479/wechatback/getInteboCorpCode?state="+encodeURIComponent("//intebo.shmiaojie.cn/#/intebologin");
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getInteboCorpCode?state="+encodeURIComponent("intebo.shmiaojie.cn/#/intebologin");
        }
    },
    methods:{
        getCorpUserInfo(staffid){
            this.$post("/wechat/getCorpUserInfo",{staffid:staffid}).then((res)=>{
            if(res.sucess) {
                let data = res.object;
                if (data.staff == null || data.staff == undefined) {
                    //如果钉钉没找到就关闭页面
                    this.$dialog.alert({
                        title: "提示",
                        message: "没有找到您的信息"
                    }).then(() => {
                        window.WeixinJSBridge.call('closeWindow');
                    });
                    return;
                }
                else {
                    let posid=data.staff.posid;
                    //if(posid=="d6511059fec84700a91a86e43436fd58" || posid=="9132ffd069fd494687c1c9bc929baf5d" 
                    //|| posid=="ceb744d8bb9747849b3c7e997d0df357" || posid=="b0cfe2a583f6422aa1f0418ec1ea0ac3"){
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        this.$router.push("/intebocashtabbar");
                    //}
                    //else{
                      //  this.$router.push("/error");
                       // localStorage.clear();
                    //}
                    
                }
            }
            else{
                this.$dialog.alert({
                    title:"提示",
                    message:res.message
                }).then(()=>{
                    window.WeixinJSBridge.call('closeWindow');
                });
            }
            });
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebologin.vue